import React, { useContext, useEffect, useState } from 'react';
import { defaultTheme } from '../themes/index.js';
import icon_edit from '../../../components/icons/edit.webp'
import icon_share from '../../../components/icons/share.webp';
import { IconShare2 } from '@tabler/icons-react';
import Share from './Share.jsx';
import { AppContext } from '../../../AppContextProvider.jsx';
const sizeMap = {
  sm: { width: '95%',maxWidth:250, minHeight: 170, padding: '1.25rem 1.5rem', titleSize: 15, msgSize: 10 },
  md: { width: '100%',maxWidth:270, minHeight: 150, padding: '1rem 1rem',       titleSize: 15, msgSize: 10 },
  lg: { width: 560,maxWidth:600, minHeight: 340, padding: '2.5rem 2.5rem',   titleSize: 36, msgSize: 16 },
};

export function GreetingCard({ content, theme = defaultTheme, size = 'md', orientation = 'landscape', showControl='true',showDate = false, className = '', style = {}, onClick }) {
  const s = sizeMap[size];
  const isPortrait = orientation === 'portrait';
  const [devise,setDevise] = useState('€');
  const [AppState,setAppState] = useContext(AppContext);

  useEffect(()=>{
    if(AppState.settings.devise==='euro')
      setDevise('€');
    else
      setDevise('KMF');
  },[AppState.settings.devise])

  const cardStyle = {
    width: isPortrait ? s.minHeight : s.width,
    maxWidth:s.maxWidth,
    minHeight: isPortrait ? s.width : s.minHeight,
    background: theme.background,
    color: theme.color,
    borderRadius: 16,
    padding: s.padding,
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    margin:'auto',
    justifyContent: 'space-between',
    cursor: onClick ? 'pointer' : 'default',
    fontFamily: theme.fontFamily || "'Playfair Display', Georgia, serif",
    boxSizing: 'border-box',
    ...style,
  };

  const decoStyle = {
    position: 'absolute',
    fontSize: s.titleSize * 2.8,
    opacity: 0.07,
    lineHeight: 1,
    pointerEvents: 'none',
    fontFamily: "'Playfair Display', Georgia, serif",
    userSelect: 'none',
  };

  return (
    <div style={cardStyle} className={`gc-card ${className}`} onClick={onClick}>
      <span style={{ ...decoStyle, top: -10, left: -6 }}>{theme.ornament}</span>
      <span style={{ ...decoStyle, bottom: -20, right: -6, transform: 'rotate(180deg)' }}>{theme.ornament}</span>

      <div style={{ position: 'relative', zIndex: 1 }}>
        {content.to && (
          <p style={{ fontSize: s.msgSize - 1, opacity: 0.55, marginBottom: 6, letterSpacing: '0.06em' }}>
            Pour {content.to}
          </p>
        )}
        {content.title && (
          <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: s.titleSize-3, fontWeight: 500, lineHeight: 1.2, marginBottom: 5, color: theme.color }}>
            {content.title}
          </h2>
        )}
        {content.message && (
          <p style={{ fontSize: s.msgSize-2, lineHeight: 1.75, fontStyle: 'italic', opacity: 0.85, fontFamily: "'Lato', sans-serif", fontWeight: 300 }}>
            {content.message}
          </p>
        )}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', position: 'relative', zIndex: 1, marginTop: '0.5rem' }}>
        <div>
          {content.from && (
            <div style={{textAlign:'left'}}>
              <span style={{ fontSize: s.msgSize - 2, opacity: 0.5, letterSpacing: '0.06em' }}>De la part de</span>
              <p style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: s.msgSize - 2, fontStyle: 'italic', marginTop: 2, color: theme.color,marginBottom:'0px' }}>
                {content.from}
              </p>
              {showDate && content.date && (
                <p style={{ fontSize: s.msgSize - 2, opacity: 0.4, marginTop: 2 }}>{content.date}</p>
              )}
              { (showControl) &&
                <div style={{display:'flex',flexDirection:'row'}}>
                    {(content.owner_is_editable) && <Share theme={theme} content={content} style={{fontSize:s.msgSize - 3}} />}
                    <input type='button' style={{backgroundColor:theme.background,borderStyle:'none',maxWidth:'60px',fontSize:s.msgSize-3,color:theme.color,border:`1px solid ${theme.color}80`,borderRadius:'10px',padding:'1px 2px'}} value={"QR CODE"} />
                </div>
              }
            </div>
          )}
        </div>
        <div style={{position:'relative'}}>
          { /*!!content.balance &&*/ (
          <div style={{ textAlign: 'right',marginBottom:'-20px'}}>
            <span style={{ fontSize: s.msgSize - 2, opacity: 0.5, letterSpacing: '0.06em', display: 'block' }}>
              Solde disponible
            </span>
            <p style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: s.titleSize * 0.85, fontWeight: 600, marginTop: 2, color: theme.accentColor }}>
              {`${content.value} ${devise}`}
            </p>
          </div>)}
          <span style={{ fontSize: s.titleSize * 0.7, opacity: 0.4 }}>{theme.ornament}</span>
        </div>
        
      </div>
    </div>
  );}

export default GreetingCard;
